<template>
  <div class="flex justify-center">
      <div class="flex text-xs md:text-base" v-for="(s,i) in sections" :key="s" >
        <template v-if="!hideCrumbs">
          <div @click="setActiveSection(i)" :class="{'text-gray-500': s !== activeSection,'text-orange-500':s ===activeSection, 'hover:text-orange': true, 'hover:underline': true}">
            {{s}}
          </div>
          <div v-if="i+1 != sections.length" class="px-2">&bull;</div>
        </template>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    sections: Array,
    activeSection: String,
    hideCrumbs: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setActiveSection (i) {
      this.$emit('change', i)
    }
  }
}
</script>

<style>

</style>
